module.exports = __webpack_public_path__ + "img/watermark-quarter.2e511574.svg";